export default __webpack_public_path__ + "static/title-pix-9d80a5c9875f9ad51c43bad6310d6a73.jpg";